import { FunctionComponent } from 'react'

type DistributionProps = {
	distribution: number[]
	min: number
	max: number
}

const Distribution: FunctionComponent<DistributionProps> = props => {
	const { distribution, min, max } = props
	// const distribution = [0, 3, 6, 5, 12]
	// const min = 1
	// const max = 5

	const rows = []
	const maxResult = Math.max(...distribution)
	const totalPlayed = distribution.reduce((acc, val) => acc + val, 0)
	// const total = stats.getGamesPlayed()

	for (let i = min; i <= max; i++) {
		const stars = distribution[i - min] || 0
		const width = stars ? (100 / maxResult) * stars : 0
		const percentage = Math.round((stars / totalPlayed) * 100) || 0

		let className = `distribution__row`
		if (stars === 0) className += ` distribution__row--empty`
		rows.push(
			<div key={`row${i}`} className={className}>
				<div className="distribution__label">{i === -1 ? '💔' : `${i} ⭐`}</div>

				<div className="distribution__val">
					<div className="distribution__bar" style={{ width: `${width}%` }}>
						{stars}
					</div>
				</div>
				<div className="distribution__label">{percentage}%</div>
			</div>
		)
	}

	return <div className="distribution">{rows}</div>
}

export default Distribution
